// extracted by mini-css-extract-plugin
export default {"Wrapper":"ProfileView_Wrapper__y-IY8","Main":"ProfileView_Main__Yc2fC","Section":"ProfileView_Section__6wGvI"};